export default __webpack_public_path__ + "static/media/corelDraw.0541b02c.svg";